import { Button, Chip, Grid, Typography } from '@mui/material'
import { Area } from 'api/vehicle/taxisRatesAPI.types'
import Input from 'components/RouteWizard/Input'
import React from 'react'

interface TaxiRateAreasProps {
  areas?: Area[]
  onChange: (areas: Area[]) => void
  isEdit?: boolean
}

export const TaxiRateAreas: React.FC<TaxiRateAreasProps> = ({
  areas,
  onChange,
  isEdit,
}) => {
  const [areaList, setAreaList] = React.useState<Area[]>(areas || [])
  const [area, setArea] = React.useState<Area>({
    postCode: '',
  })

  console.log('TaxiRateAreas areaList: ', areaList)

  React.useEffect(() => {
    if (areaList.length > 0) {
      onChange(areaList)
    }
  }, [areaList, onChange])

  const handleDeleteArea = (areaToDelete: Area) => {
    setAreaList(
      areaList.filter((area) => area.postCode !== areaToDelete.postCode),
    )
  }
  const handleAddServicedArea = () => {
    console.log('handleAddServicedArea area: ', area)
    if (area && area.postCode !== '') {
      const cleaned = area.postCode.trim()
      let areaCodes: Array<Area> = []
      if (cleaned.includes(',')) {
        cleaned.split(/[,]+/).map((val) => {
          val && areaCodes.push({ postCode: val })
        })
      } else {
        areaCodes.push({ postCode: cleaned })
      }
      const mergedServicedAreas = [...areaList, ...areaCodes]
      const uniqueServicedAreas = Array.from(
        new Set(mergedServicedAreas.map((a) => a.postCode)),
      ).map((postCode) => {
        return mergedServicedAreas.find((a) => a.postCode === postCode)
      })
      setAreaList(uniqueServicedAreas.filter((area) => area !== undefined))
      setArea({ postCode: '' })
    }
  }

  return (
    <Grid container spacing={2} maxWidth={'lg'} sx={{ marginTop: '-40px' }}>
      <Grid item xs={12}>
        <Grid container spacing={0} sx={{ flexWrap: 'wrap' }}>
          {areaList
            ?.sort((a, b) => a.postCode.localeCompare(b.postCode))
            .map((area, i) => (
              <Grid
                item
                key={`${area.postCode}_${i}_${area.id}`}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Chip
                  label={area.postCode}
                  color="primary"
                  variant="outlined"
                  onDelete={isEdit ? () => handleDeleteArea(area) : undefined}
                  sx={{ margin: '4px', width: '120px' }}
                />
              </Grid>
            ))}
        </Grid>
      </Grid>
      {isEdit && (
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={1}>
            <Button
              onClick={() => handleAddServicedArea()}
              sx={{ paddingRight: '10px', textAlign: 'right' }}
            >
              Add Area
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Input
              name="area"
              value={area.postCode}
              onChange={(e) =>
                setArea({ postCode: e.target.value.toUpperCase() })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" color="text.secondary">
              INFO: You can paste a list of postcodes separated by commas to add
              multiple areas at once e.g. N1,N2,E10
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
